/** Faz o empilhamento correcto de modais bs5 abertos em simultâneo (ex.: o
 * teclado numérico aberto por cima do modal de finalizar venda).
 *
 * Por omissão, o bs5 atribui o mesmo z-index (CSS estático) a todos os
 * `.modal.show`, pelo que dois modais abertos ao mesmo tempo ficam ordenados
 * pela posição no DOM em vez da ordem de abertura — o modal aberto por
 * último podia ficar visualmente atrás do primeiro, tornando-o invisível/
 * inacessível, e ao fechá-lo o modal de baixo perdia o seu backdrop.
 * Esta função (chamada uma única vez, ao arrancar a app) escuta os eventos
 * nativos do bs5 e atribui um z-index crescente a cada modal + o seu
 * backdrop, na ordem real em que são abertos. O valor base (10000) fica
 * acima de elementos fixos do POS como a `.pos_tabbar` (z-index 9999). */
export function empilharModaisBs5(): void {
  const BASE = 10000;
  let abertos = 0;

  document.addEventListener("show.bs.modal", (event) => {
    abertos++;
    const alvo = event.target;
    if (alvo instanceof HTMLElement) {
      alvo.style.zIndex = String(BASE + abertos * 20);
    }
  });

  document.addEventListener("shown.bs.modal", () => {
    const modaisAbertos = document.querySelectorAll<HTMLElement>(".modal.show");
    const ultimoModal = modaisAbertos[modaisAbertos.length - 1];
    const backdrops = document.querySelectorAll<HTMLElement>(".modal-backdrop");
    const ultimoBackdrop = backdrops[backdrops.length - 1];
    if (ultimoModal && ultimoBackdrop) {
      ultimoBackdrop.style.zIndex = String(
        Number(ultimoModal.style.zIndex || BASE) - 1,
      );
    }
  });

  document.addEventListener("hidden.bs.modal", () => {
    abertos = document.querySelectorAll(".modal.show").length;
  });
}
